import { SectionType } from '../enums/mediaTypes.ts';

export const isMovieOrTv = (type: SectionType): type is SectionType.Movie | SectionType.Tv =>
  type === SectionType.Movie || type === SectionType.Tv;
